export default __webpack_public_path__ + "static/media/reclamtion.177c55df.png";